module.exports = __webpack_public_path__ + "img/video_example.34f18f89.png";